import { render, staticRenderFns } from "./order_form.vue?vue&type=template&id=37b436ac&"
import script from "./order_form.vue?vue&type=script&lang=js&"
export * from "./order_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports